import React from 'react';

interface UserTypeBadgeProps {
  role?: string | null;
  className?: string;
  compact?: boolean;
}

const roleStyles: Record<string, string> = {
  admin: 'border-purple-500/20 bg-purple-500/10 text-purple-400',
  trader: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-400',
  investor: 'border-cyan-500/20 bg-cyan-500/10 text-cyan-400',
  viewer: 'border-blue-500/20 bg-blue-500/10 text-blue-400',
};

const roleLabels: Record<string, string> = {
  admin: 'Admin',
  trader: 'Trader',
  investor: 'Investor',
  viewer: 'Viewer',
};

const UserTypeBadge: React.FC<UserTypeBadgeProps> = ({
  role,
  className = '',
  compact = false,
}) => {
  const key = role?.trim().toLowerCase() || '';
  const label = roleLabels[key] || role?.trim() || 'Account';
  const sizeClasses = compact
    ? 'px-1.5 py-0.5 text-[8px]'
    : 'px-2.5 py-0.5 text-xs';

  return (
    <span
      aria-label={`User type: ${label}`}
      title={`User type: ${label}`}
      className={`inline-flex shrink-0 items-center rounded-full border font-semibold leading-none ${sizeClasses} ${roleStyles[key] || 'border-white/10 bg-white/5 text-muted'} ${className}`}
    >
      {label}
    </span>
  );
};

export default UserTypeBadge;
